import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  modals: [],
};

// A burst of errors would otherwise stack up the whole screen; the oldest
// makes room.
const MAX_VISIBLE = 4;

const statusModalSlice = createSlice({
  name: "statusModal",
  initialState,
  reducers: {
    showModal: (state, action) => {
      // The same message again (e.g. a load failing on every retry) replaces
      // the one on screen — its timer restarts — instead of stacking a copy.
      state.modals = state.modals.filter(
        (modal) =>
          modal.message !== action.payload.message ||
          modal.status !== action.payload.status,
      );
      state.modals.push({
        // Not Date.now(): two toasts in the same millisecond shared an id, so
        // closing one closed both.
        id: nanoid(),
        message: action.payload.message,
        status: action.payload.status,
      });
      if (state.modals.length > MAX_VISIBLE) {
        state.modals.splice(0, state.modals.length - MAX_VISIBLE);
      }
    },
    hideModal: (state, action) => {
      state.modals = state.modals.filter(
        (item) => item.id !== action.payload.id
      );
    },
  },
});

export const { showModal, hideModal } = statusModalSlice.actions;

export default statusModalSlice.reducer;
